import React from "react";

const ManageUserTabs = ({ activeTab, tabs, onTabChange }) => {
  return (
    <div className="mt-4 flex w-full gap-2 overflow-x-auto rounded-sm bg-[#F5F5F5] px-2 py-1.5 sm:inline-flex sm:max-w-[422px] sm:flex-wrap sm:gap-3 sm:px-3">
      {tabs.map((tab) => {
        const isActive = activeTab === tab;

        return (
          <button
            key={tab}
            type="button"
            onClick={() => onTabChange(tab)}
            className={[
              "shrink-0 rounded px-3 py-1.5 text-sm font-semibold tracking-[6%] leading-[19px] transition sm:px-4 sm:text-base",
              isActive
                ? "bg-[#923D8C] text-white"
                : "bg-transparent text-black hover:bg-white",
            ].join(" ")}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
};

export default ManageUserTabs;
